/** @format */

import React from 'react'

const Blogs = () => {
	return <div>Blogs Page</div>
}

export default Blogs
